var _ChatBotServiceInit_instances, _ChatBotServiceInit_muteBotSettings, _ChatBotServiceInit_storage, _ChatBotServiceInit_loadMuteBots, _ChatBotServiceInit_saveMuteBots;
import { __classPrivateFieldGet } from "tslib";
import { get, writable } from 'svelte/store';
import { LocalStorageManager } from '../model/storage/LocalStorageManager';
class ChatBotServiceInit {
    constructor() {
        _ChatBotServiceInit_instances.add(this);
        _ChatBotServiceInit_muteBotSettings.set(this, writable([]));
        _ChatBotServiceInit_storage.set(this, new LocalStorageManager());
        __classPrivateFieldGet(this, _ChatBotServiceInit_instances, "m", _ChatBotServiceInit_loadMuteBots).call(this);
    }
    get muteBotSettings() {
        return __classPrivateFieldGet(this, _ChatBotServiceInit_muteBotSettings, "f");
    }
    setMuteBot(botHash, mute) {
        __classPrivateFieldGet(this, _ChatBotServiceInit_muteBotSettings, "f").update(it => {
            const filtered = it.filter(setting => setting.hash !== botHash);
            return [...filtered, { hash: botHash, mute }];
        });
        __classPrivateFieldGet(this, _ChatBotServiceInit_instances, "m", _ChatBotServiceInit_saveMuteBots).call(this);
    }
}
_ChatBotServiceInit_muteBotSettings = new WeakMap(), _ChatBotServiceInit_storage = new WeakMap(), _ChatBotServiceInit_instances = new WeakSet(), _ChatBotServiceInit_loadMuteBots = function _ChatBotServiceInit_loadMuteBots() {
    const rawMuteBots = __classPrivateFieldGet(this, _ChatBotServiceInit_storage, "f").muteBotSettings;
    const muteBots = JSON.parse(rawMuteBots);
    __classPrivateFieldGet(this, _ChatBotServiceInit_muteBotSettings, "f").set(muteBots);
}, _ChatBotServiceInit_saveMuteBots = function _ChatBotServiceInit_saveMuteBots() {
    const muteBots = get(__classPrivateFieldGet(this, _ChatBotServiceInit_muteBotSettings, "f"));
    const rawMuteBots = JSON.stringify(muteBots);
    __classPrivateFieldGet(this, _ChatBotServiceInit_storage, "f").muteBotSettings = rawMuteBots;
};
export const ChatBotService = new ChatBotServiceInit();
